import { RegisteredDetails } from "../components/RegisteredDetails";
import { RegisterLayout } from "../components/RegisterLayout";
import { BRAND } from "../lib/site";

const Section = ({ n, title, children }) => (
  <section className="py-8 border-b border-white/10" data-testid={`privacy-section-${n}`}>
    <div className="grid md:grid-cols-[80px_1fr] gap-4 md:gap-10">
      <span className="font-serif text-3xl text-[#B87333]/40">{n}</span>
      <div>
        <h2 className="font-serif text-2xl md:text-3xl mb-4">{title}</h2>
        <div className="font-body text-[#C9C9C2] leading-relaxed space-y-3 max-w-2xl">{children}</div>
      </div>
    </div>
  </section>
);

export default function Privacy() {
  return (
    <RegisterLayout
      kicker="/ Legal"
      title="Privacy Policy"
      subtitle={`This Privacy Policy explains how Vinci Inc. ("Vinci Inc.", "we", "us") collects, uses and protects your information. Last updated ${new Date().getFullYear()}.`}
    >
      <div className="mt-4">
        <Section n="01" title="Who we are">
          <p><strong className="text-[#F5F5F0]">Vinci Inc.</strong> is the legal entity operating this website and the associated bulk-trading and materials commerce services (Vinci Trade Asia).</p>
          <p>Vinci Inc. operates PAN-India through a group of registered entities. Contact: <a href={`mailto:${BRAND.email}`} className="text-[#B87333] hover:underline">{BRAND.email}</a>. Registered entity and correspondence details are shared with verified trade partners on request.</p>
        </Section>
        <Section n="02" title="Information we collect">
          <p>We collect information you provide directly — including your name, business name, GST number, PAN, email, phone, delivery address and account credentials — when you register as a buyer or seller, request a quote, or place an order.</p>
          <p>We also collect limited technical data (such as device and usage information) needed to operate and secure the site.</p>
        </Section>
        <Section n="03" title="How we use your information">
          <p>To create and manage your account and partner tier; to process quotes, orders, payments, invoicing and delivery; to verify sellers; to communicate order, dispatch and account updates; and to comply with legal and tax obligations.</p>
        </Section>
        <Section n="04" title="Payments & third-party services">
          <p>Payments are processed securely by <strong className="text-[#F5F5F0]">Razorpay</strong>; we do not store your full card details. Transactional emails are sent via our email provider. These providers process data only to deliver their service.</p>
        </Section>
        <Section n="05" title="Data retention & security">
          <p>We retain personal and transactional records for as long as your account is active and as required by applicable law (including tax and accounting requirements). We apply reasonable technical and organisational measures to protect your data.</p>
        </Section>
        <Section n="06" title="Your rights">
          <p>You may request access to, correction of, or deletion of your personal information, subject to legal retention requirements. To exercise any right, contact us at <a href={`mailto:${BRAND.email}`} className="text-[#B87333] hover:underline">{BRAND.email}</a>.</p>
        </Section>
        <Section n="07" title="Cookies">
          <p>We use strictly necessary cookies to keep you signed in, maintain your cart and secure the site. We do not use cookies for advertising. You can control cookies through your browser settings; disabling essential cookies may affect site functionality. A cookie notice is shown on first visit.</p>
        </Section>
        <Section n="08" title="Contact & registered details">
          <RegisteredDetails />
        </Section>
      </div>
    </RegisterLayout>
  );
}
